import { Controller } from '@hotwired/stimulus'
import { openMobileSidebar } from '@components/MobileSidebar/mobileSidebarEvents'

// Opens the app-wide mobile navigation drawer (MobileSidebarDrawer) from a
// server-rendered (Phlex) page header. Reuses the exact `mobile-sidebar:open`
// document-event contract that React page headers fire, so no drawer state is
// duplicated. Wired by Components::Shared::MobileNavToggle.
export default class extends Controller {
  open() {
    openMobileSidebar()
  }
}
